export class Dosis {
    id: number;
    fecha: string;
    norma: string;
    edad: number;
}



// WEBPACK FOOTER //
// ./src/models/dosis.ts